export const checkedOptions = [
    { key: '0', value: '0', text: 'Active' },
    { key: '1', value: '1', text: 'Stopped' },
    { key: '2', value: '2', text: 'Completed' },
    { key: '4', value: '3', text: 'Transacted' },
    { key: '5', value: '4', text: 'Retired' },
  ]